<script lang="ts" setup>
  import { useAuthStore, useGeneratedEmployeeStateStore, useGeneratedEmployeeStore } from '@/stores'
  import Dialog from 'primevue/dialog'
  import EmployeeStateIcon from '@/elements/EmployeeStateIcon.vue'
  import { useToast } from 'primevue/usetoast'
  import { computed, onMounted, ref } from 'vue'
  import { useTitrop } from '@/composables/useTitrop.ts'
  import ButtonDefault from '@/elements/ButtonDefault.vue'
  import { EmployeeStateDefaultReadSync } from '@/api'

  const toastService = useToast()
  const statusOptions = ref<EmployeeStateDefaultReadSync[]>()

  const titrop = useTitrop()
  const showStatusChangeForm = ref(false)
  const allStates = ref<Record<string, EmployeeStateDefaultReadSync>>({})
  const newState = ref<string>()
  const statusButtonDisabler = computed(() => newState.value !== titrop.value.user.current.current_state && typeof newState.value !== 'undefined')

  const currentState = computed(() => allStates.value[titrop.value.user.current.current_state as string])
  const isLoading = ref(true)

  useTitropEvents().hotkeyToggleStatusChangeDialog.on(() => {
    showStatusChangeForm.value = true
  })

  async function changeEmployeeStatus() {
    if (!newState.value) return
    await useGeneratedEmployeeStore().putId({
      path: { id: titrop.value.user.currentId.toString() },
      body: { current_state: newState.value['@id'] }
    })
    toastService.add({ severity: 'success', life: 2500, summary: 'Status ist aktualisiert' })
    newState.value = undefined
    void useAuthStore().refreshWhoAmI()
    showStatusChangeForm.value = false
  }

  onMounted(async () => {
    allStates.value = (await useGeneratedEmployeeStateStore().findAllAsIriDictionary({}, { forceRefresh: true })).value
    statusOptions.value = Object.keys(allStates.value)
      .filter((s) => s != currentState.value['@id'])
      .map((stKey) => allStates.value[stKey])
    isLoading.value = false
  })
</script>

<template>
  <Dialog
    v-if="!isLoading"
    v-model:visible="showStatusChangeForm"
    :style="{ width: '20rem' }"
    header="Status ändern"
    modal>
    <div
      :key="$user.current.current_state"
      class="flex">
      <span>aktueller Status: {{ currentState.title }}</span>
      <EmployeeStateIcon
        :code="currentState.code"
        :size="25" />
    </div>
    <div class="flex">
      <span class="mt-2 mr-1">neuer Status:</span>
      <Dropdown
        v-model="newState"
        :options="statusOptions"
        :style="{ width: '10rem' }"
        option-label="title" />
    </div>
    <div class="flex justify-end">
      <ButtonDefault
        :disabled="!statusButtonDisabler"
        class="disabled:text-gray-300 mt-2"
        @click="changeEmployeeStatus">
        Aktualisieren
      </ButtonDefault>
    </div>
  </Dialog>
</template>
